import { Progress, ProgressType } from '../@types/progress'
import { STEP } from '../@types/state'
import { FlowType } from '../@types/flowType'
import { progressMap as regularProgressMap } from './regularFlowConfig'
import { progressMap as landProgressMap } from './landFlowConfig'
import { progressMap as commercialProgressMap } from './commercialFlowConfig'
import { WizardFlowType } from '../@types/wizardFlowType'

export const DEFAULT_PROGRESS = { previous: 0, current: 0, next: 0 }

const map: { [key in FlowType]: Record<string, ProgressType> } = {
  [FlowType.REGULAR]: regularProgressMap,
  [FlowType.LAND]: landProgressMap,
  [FlowType.COMMERCIAL]: commercialProgressMap,
}

export const progress =
  (wizardFlowType: WizardFlowType, flowType: FlowType) =>
  (step: STEP): Progress => {
    const result = map[flowType][wizardFlowType][step]
    return result || DEFAULT_PROGRESS
  }
